module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Traductions","btnAdd":"Ajouter une traduction"},"en":{"title":"Translations","btnAdd":"Add a translation"}}')
  delete Component.options._Ctor
}
